import * as React from 'react'

const styles = {
  main: {
    zIndex: 10000,
    backgroundColor: 'rgba(16, 16, 16, 0.5)',
    paddingBottom: '100px'
  } as React.CSSProperties,
  list: {
    minHeight: '100%',
    justifyContent: 'flex-end'
  } as React.CSSProperties
}

export interface Message {
  eventID: string
  userID: string
  userName: string
  message: string
  createdAt: number
}

export interface Props {
  messages: Array<Message>
}

export default class MessageDialogue extends React.Component<Props> {
  private latestRef: Element | null = null

  componentDidUpdate () {
    // TODO: only scroll when we are viewing the bottom
    // also add animation?
    // also only scroll when the latest ref changes?
    if (this.latestRef) {
      this.latestRef.scrollIntoView()
    }
  }

  render () {
    const messages = this.props.messages.map((message, index) => {
      const latest = index === this.props.messages.length - 1
      const extraProps = latest ? { ref: this.onRef } : {}
      return (
        <li {...extraProps} key={message.eventID} className='white pb1'>
          <div className='bold'>{message.userName}:</div>
          <div className='py1 break-word'>{message.message}</div>
        </li>
      )
    })
    // TODO: scroll to new message
    return (
      <div
        className='absolute top-0 left-0 bottom-0 p2 col-2 pb4 overflow-scroll'
        style={styles.main}>
        <ul style={styles.list} className='list-reset flex flex-column my0'>
          {messages}
        </ul>
      </div>
    )
  }

  private onRef = (ref: Element) => {
    this.latestRef = ref
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageDialogue.tsx